module.exports = __webpack_public_path__ + "static/media/call-quality-poor.9aa959dc.svg";